<div class="table-holder table-responsive">
  <table class="table table-default table-striped">
    <mat-table #table matSort [dataSource]="dataSource" class="table-without-select">
      <ng-container matColumnDef="sent">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n> Date</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.sent | epoch }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="action">
        <mat-header-cell *matHeaderCellDef> Message</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <ng-container *ngIf="!!element.notes?.length">
            {{ element.notes?.join(', ') }}
          </ng-container>
          <ng-container *ngIf="!element.notes?.length" i18n>
            Click here to view the associated item that caused the trigger.
          </ng-container>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns" (click)="onDetails(row)" class="clickable"></mat-row>
    </mat-table>

    <mat-paginator2
      #paginator
      [length]="dataSource?.data?.length"
      [class.hidden]="!dataSource?.filteredData?.length"
      [pageSize]="10"
      [pageSizeOptions]="[5, 10, 20, 50, 75, 100]"
      [showFirstLastButtons]="true"
      i18n-ariaLabel="Pagination navigation"
    >
    </mat-paginator2>

    <app-empty-table *ngIf="isEmptyTable$ | async" [type]="tableType"></app-empty-table>
  </table>
</div>
